import React, { useContext } from "react"

import { PriceContext } from "@features/Price/PriceContext"

import RenderMobileTariff from "../RenderMobileTariff"
import Available from "../Available"
import Disabled from "../Disabled"
import RequestPrice from "../RequestPrice"
import AddonPriceControl from "../AddonPriceControl"

import * as styles from "./style.module.scss"

export interface AddonColumn {
  bucket: string
  value: number | string | null
}

interface OneAddonProps {
  addonKey: string
  name: string
  description?: string
  columns: AddonColumn[]
  // Публичная: платные ячейки показывают «по запросу» при трафике ≥100k (isRequest). v424: false.
  requestByTier?: boolean
}

// Единый leaf-рендерер строки аддона для обоих движков (public /price/ и *-v424).
const OneAddon = ({ addonKey, name, description, columns, requestByTier = false }: OneAddonProps) => {
  const { text } = useContext(PriceContext)

  const rowLayoutClassName = columns.length === 1 ? styles.addonRowTwoColumns : styles.addonRowFourColumns

  const renderCell = (value: number | string | null, bucket: string) => {
    if (value === 1) return <Available />
    if (value === 0) return <Disabled />
    if (value === 2) {
      return <div className={styles.request} dangerouslySetInnerHTML={{ __html: text.addonText.request_cta }} />
    }
    // "tg" — маркер публичной; null — маркер v424; requestByTier — tier ≥100k на публичной
    if (value === "tg" || value == null || requestByTier) return <RequestPrice />

    return <AddonPriceControl price={value as number} bucket={bucket} title={name} addonKey={addonKey} />
  }

  return (
    <div>
      <div className={styles.addonWrapper}>
        <div className={styles.addonHeaderMobile}>
          <p className={styles.addonTitle}>{name}</p>
          {description && <p className={styles.addonDescription}>{description}</p>}
        </div>

        <div className={`${styles.addonRow} ${rowLayoutClassName}`}>
          <div className={styles.addonHeaderDesktop}>
            <p className={styles.addonTitle}>{name}</p>
            {description && <p className={styles.addonDescription}>{description}</p>}
          </div>

          {columns.map(({ bucket, value }, index) => (
            <div key={bucket} className={styles.addonOptionColumn}>
              <RenderMobileTariff index={index} />
              {renderCell(value, bucket)}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default React.memo(OneAddon)
